"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REVIEW_OPT_OUT = exports.REVIEW_OPT_IN = exports.SEARCH_QUERY_SUBMITTED = exports.USER_CREATED = exports.USER_ACTIVITY = exports.LOGIN = void 0; // Activity

exports.LOGIN = "login";
exports.USER_ACTIVITY = "userActivity";
exports.USER_CREATED = "userCreated"; // Help

exports.SEARCH_QUERY_SUBMITTED = "searchQuerySubmitted"; // Reviews

exports.REVIEW_OPT_IN = "reviewOptIn";
exports.REVIEW_OPT_OUT = "reviewOptOut";